import React, { useEffect, useState } from "react";
import LeaderBordSelect from "./LearderBoardSelect";
import Podium from "./Pudium";
import UsersRateList from "./UsersRateList";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import { useDispatch, useSelector } from "react-redux";
import { setLBFetchLoading } from "../../assets/redux/actions/Quiz";
import Loading from "../../assets/containers/loadingDialog";
import UsersRequests from "../../assets/services/user";
import LeaderBoardRequests from "../../assets/services/leaderBoard";

const LeaderBoardPage = () => {
  const [leaderBoardType, setLeaderBoardType] = useState("monthly");
  const dispatch = useDispatch();
  const { LBFetchLoading } = useSelector(({ quiz }) => quiz);

  useEffect(() => {
    dispatch(LeaderBoardRequests.GetLeaderBoard(leaderBoardType));
    dispatch(UsersRequests.getUserScore());
    return () => {
      dispatch(setLBFetchLoading(false));
    };
  }, [leaderBoardType]);

  const handleChangeLeaderBordType = (type) => {
    setLeaderBoardType(type);
  };

  return (
    <AnimatedPageContainer>
      <div className={"customContainer"}>
        <div>
          <LeaderBordSelect
            activeItem="monthly"
            type={leaderBoardType}
            handleChange={handleChangeLeaderBordType}
          />
          {!LBFetchLoading ? (
            <Podium type={leaderBoardType} />
          ) : (
            <Loading
              size={40}
              light
              className={"w-100 d-flex justify-content-center py-5"}
            />
          )}
        </div>
        {!LBFetchLoading ? <UsersRateList type={leaderBoardType} /> : null}
      </div>
    </AnimatedPageContainer>
  );
};

export default LeaderBoardPage;
